// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { motion, useAnimation } from 'framer-motion';
import { Box, Image, Divider, Button, Grid, Text, Flex, Skeleton, useColorModeValue } from '@chakra-ui/react';
import { NavLink, Link, useHistory } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import placeholder from 'assets/img/placeholder-category.png';
import search from 'assets/svg/search.svg';

// Components
import Card from 'components/Card/Card';

const Categories = () => {
    const textColor = 'white';
    const borderColor = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');
    const boxShadow = useColorModeValue('unset','0px 1px 22px 0px rgba(9, 155, 255, 0.60)');

    const { data, isLoading } = useQuery({
        queryKey: ['categories'],
        queryFn: async () => {
            const response = await apiService.getCategories({ limit: 25, offset: 0, featured: true });
            return response.data;
        },
        refetchOnWindowFocus: false
    });

    const history = useHistory();
    const handlePage = (id) => {
        let param = '';
        if(id){
            param = `?category=${id}`;
        }
        history.push(`/discounts/partners${param}`); 
    };

    return (
    	<>
    	{ isLoading ? ( 
            <Grid mt={{base: '-28px', md: '16px'}} 
                templateColumns={{ base: '1fr 1fr', md: '1fr 1fr 1fr 1fr', lg: '1fr 1fr 1fr 1fr 1fr 1fr' }} 
                gap={{ base: '8px', md: '24px'}} templateRows='1fr' pb="24px">
                <Skeleton height="130px" borderRadius="16px" />
                <Skeleton height="130px" borderRadius="16px" />
                <Skeleton height="130px" borderRadius="16px" />
                <Skeleton height="130px" borderRadius="16px" />
                <Skeleton height="130px" borderRadius="16px" />
                <Skeleton height="130px" borderRadius="16px" />
            </Grid>
        ) : (
	        <Grid mt={{base: '-28px', md: '16px'}} pb="24px"
                templateColumns={{ base: '1fr 1fr', md: '1fr 1fr 1fr 1fr', lg: '1fr 1fr 1fr 1fr 1fr 1fr' }} 
                gap={{ base: '8px', md: '24px'}} templateRows='1fr'>
	        	{ data?.map((item, index) => (
			        <Card
                        cursor="pointer"
                        key={index}
                        onClick={() => handlePage(`${item?.id}`)} 
                        padding="26px 26px 18px 26px"
                        transition="0.3s all"
                        _hover={{
                           boxShadow: '0px 1px 22px 0px rgba(9, 155, 255, 0.60)'  
                        }}
                        textAlign="center"
                        minH="130px">
			        	<Image p="3px" m="0 auto" src={item?.image ?? placeholder} alt="category" w="40px" h="40px" />
			        	<Text variant="title-md" fontWeight="700" mt="5px" lineHeight="17px">{item?.name}</Text>
			        </Card>
			    ))}

                <Card
                    onClick={() => handlePage('')} 
                    cursor="pointer"
                    padding="26px"
                    border={borderColor}
                    bg="linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)"
                    boxShadow={boxShadow} 
                    textAlign="center" 
                    minH="130px">
                    <Image p="3px" m="0 auto" src={search} alt="category" w="40px" h="40px" />
                    <Text variant="title-md" fontWeight="700" mt="5px" lineHeight="17px" color={textColor}>Discover</Text>
                </Card>
	        </Grid>
	    )}
	    </>
    );
};


export default Categories;